import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeResearchReportFields {
  subscriptionType: EntryFieldTypes.Symbol<'Maths' | 'Reading'>
  domains: EntryFieldTypes.Array<
    EntryFieldTypes.Symbol<'all' | 'au' | 'ca' | 'cn' | 'in' | 'kr' | 'nz' | 'th' | 'uk' | 'us' | 'za'>
  >
  title: EntryFieldTypes.Symbol
  description?: EntryFieldTypes.Text
  cover: EntryFieldTypes.AssetLink
  file: EntryFieldTypes.AssetLink
  product?: EntryFieldTypes.Symbol<'fast_phonics' | 'mathseeds' | 'reading_eggs' | 'reading_eggspress'>
  internalName?: EntryFieldTypes.Symbol
}

export type TypeResearchReportSkeleton = EntrySkeletonType<TypeResearchReportFields, 'researchReport'>
export type TypeResearchReport<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeResearchReportSkeleton,
  Modifiers,
  Locales
>

export function isTypeResearchReport<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeResearchReport<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'researchReport'
}

export type TypeResearchReportWithoutLinkResolutionResponse = TypeResearchReport<'WITHOUT_LINK_RESOLUTION'>
export type TypeResearchReportWithoutUnresolvableLinksResponse = TypeResearchReport<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeResearchReportWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> = TypeResearchReport<
  'WITH_ALL_LOCALES',
  Locales
>
export type TypeResearchReportWithAllLocalesAndWithoutLinkResolutionResponse<Locales extends LocaleCode = LocaleCode> =
  TypeResearchReport<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeResearchReportWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeResearchReport<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
